import { TAllIntegrations } from './integrations'

export const TOAST_INTEGRATION_TYPE_MAPPING: Record<TAllIntegrations, string> =
    {
        microsoft: 'Microsoft 365',
        google: 'Google Workspace',
        ms_fraud_defense: 'Microsoft 365',
        google_fraud_defense: 'Google Workspace',
        crowdstrike: 'Crowdstrike',
    }

export const CLOUD_APP_INTEGRATION_TYPES: TAllIntegrations[] = [
    'microsoft',
    'ms_fraud_defense',
]
